export const TEMPLATE_CATEGORIES = [
  { id: 'all', label: 'All' },
  { id: 'ads', label: 'Ads' },
  { id: 'hooks', label: 'Hooks & CTAs' },
  { id: 'avatars-style', label: 'Avatars & Style' },
  { id: 'creator-styles', label: 'Creator Styles' },
  { id: 'product-demos', label: 'Product Demos' },
  { id: 'talking-head', label: 'Talking Head' },
];

export const TEMPLATE_CATALOG = [
  {
    id: 'ugc-ads',
    title: 'UGC Ads',
    shortTitle: 'UGC',
    category: 'ads',
    categoryLabel: 'Ads',
    route: '/templates/ugc-ads',
    description: 'Generate product-led UGC ad concepts, pick the winners, and produce scroll-ready videos.',
    summary: 'Creator-led product ad videos from a product brief and assets.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'orange',
  },
  {
    id: 'localize-ad',
    title: 'Localize Ad',
    shortTitle: 'Localize',
    category: 'ads',
    categoryLabel: 'Ads',
    route: '/templates/localize-ad',
    description: 'Translate and adapt an existing social ad for a new language and market with Gemini Omni Flash.',
    summary: 'Market-ready visual and voice localization from an existing ad.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'cyan',
  },
  {
    id: 'hook-changer',
    title: 'Hook Changer',
    shortTitle: 'Hooks',
    category: 'hooks',
    categoryLabel: 'Hooks',
    route: '/templates/hook-changer',
    description: 'Upload a video, generate fresh opening hooks, and rebuild versions with the original structure.',
    summary: 'New first-second hooks from an existing video.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'green',
  },
  {
    id: 'change-avatar',
    title: 'Change Avatar',
    shortTitle: 'Avatar',
    category: 'avatars-style',
    categoryLabel: 'Avatars & Style',
    route: '/templates/change-avatar',
    description: 'Choose a saved or library character and rebuild the same video with that presenter.',
    summary: 'Replace the presenter using a library character.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'teal',
  },
  {
    id: 'change-style',
    title: 'Change Style',
    shortTitle: 'Style',
    category: 'avatars-style',
    categoryLabel: 'Avatars & Style',
    route: '/templates/change-style',
    description: 'Generate visual style treatments and rebuild your video with a new look while keeping the message.',
    summary: 'Fresh art direction from an existing video.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'yellow',
  },
  {
    id: 'change-cta',
    title: 'Change CTA',
    shortTitle: 'CTA',
    category: 'hooks',
    categoryLabel: 'Hooks & CTAs',
    route: '/templates/change-cta',
    description: 'Generate new call-to-action endings and rebuild versions that preserve the original body.',
    summary: 'New conversion asks from an existing video.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'red',
  },
  {
    id: 'zack-d-style-shorts',
    title: 'Zack D. Style Shorts',
    shortTitle: 'Zack D.',
    category: 'creator-styles',
    categoryLabel: 'Creator Styles',
    route: '/templates/zack-d-style-shorts',
    description: 'Create short-form videos from a brief and optional assets using the Zack D. shorts format.',
    summary: 'Short-form creator-style videos from scratch.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'pink',
  },
  {
    id: 'fern-style-youtube-video',
    title: 'Fern Style YouTube Video',
    shortTitle: 'Fern',
    category: 'creator-styles',
    categoryLabel: 'Creator Styles',
    route: '/templates/fern-style-youtube-video',
    description: 'Create a cinematic explainer-style YouTube video from a description and optional media.',
    summary: 'Narrative YouTube explainer videos from scratch.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'cyan',
  },
  {
    id: 'saas-product-demo',
    title: 'SaaS Product Demo',
    shortTitle: 'SaaS',
    category: 'product-demos',
    categoryLabel: 'Product Demos',
    route: '/templates/saas-product-demo',
    description: 'Create a polished SaaS product walkthrough from a brief, screenshots, videos, or audio.',
    summary: 'Product demo videos from a description and assets.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'lime',
  },
  {
    id: 'studio-talking-head',
    title: 'Studio Talking Head',
    shortTitle: 'Studio',
    category: 'talking-head',
    categoryLabel: 'Talking Head',
    route: '/templates/studio-talking-head',
    description: 'Turn recorded or uploaded webcam footage into a polished studio-grade launch video.',
    summary: 'Talking-head transformation with style presets and recording tools.',
    estimate: 'Pro',
    credits: 'Usage based',
    accent: 'blue',
  },
];

export function getTemplateById(templateId) {
  return TEMPLATE_CATALOG.find((template) => template.id === templateId) || null;
}
